/**
 * remoteControl — 後台遠端關鎖 / 解鎖機台(黑屏)
 *
 * 移植自新站 SDK(cli-integrated-api)useClientWebSocket 的 remote_off / remote_on(2026-10-07),
 * 2026-10-14 同步到傳統站,行為與新站一致。
 *
 * WS 訊息格式:{ type: "remote_off" | "remote_on", member_info_uid: ["機台編號", ...], data: null }
 *   · member_info_uid 是「機台編號」陣列(不是會員 uid),跟會員資料的 machine_number 比對,
 *     以字串、不分大小寫比對
 *   · remote_off 命中 → 通知外殼 closethismic(打開黑屏)+ 系統音效 IsMute
 *   · remote_on  命中 → 通知外殼 openthismic(關閉黑屏)+ 系統音效 unMute
 *
 * 外殼是 AppGo / WebView2:走 window.chrome.webview.postMessage(JSON 字串)。
 * 一般瀏覽器(手機 / 電腦)沒有 webview → 什麼都不做,只在 console 留紀錄。
 */

export const REMOTE_TYPES = ["remote_off", "remote_on"];

/** 送一則訊息給原生外殼;不是 WebView2 環境就忽略 */
export const postAppMessage = (payload) => {
  if (typeof window !== "undefined" && window.chrome?.webview) {
    window.chrome.webview.postMessage(JSON.stringify(payload));
  }
};

/** 本機機台編號是否在推播名單內 */
export const isMachineTargeted = (list, machineNumber) =>
  Array.isArray(list) &&
  machineNumber != null &&
  String(machineNumber) !== "" &&
  list.some(
    (m) => String(m).toLowerCase() === String(machineNumber).toLowerCase(),
  );

/**
 * 處理 remote_off / remote_on。
 * @param {{type:string, member_info_uid:any}} parsed WS 訊息
 * @param {string|number|null} machineNumber 會員資料的 machine_number
 * @returns {boolean} 是否為遠端關鎖類訊息(是的話呼叫端就不用往下處理)
 */
export const handleRemoteControl = (parsed, machineNumber) => {
  const type = parsed?.type;
  if (!REMOTE_TYPES.includes(type)) return false;

  const isOff = type === "remote_off";
  const matched = isMachineTargeted(parsed?.member_info_uid, machineNumber);
  console.log(`[WS ${type}]`, {
    machine_number: machineNumber,
    targets: parsed?.member_info_uid,
    matched,
    sent: matched ? (isOff ? "closethismic" : "openthismic") : null,
    volume: matched ? (isOff ? "IsMute" : "unMute") : null,
    webview: !!(typeof window !== "undefined" && window.chrome?.webview),
  });
  if (matched) {
    postAppMessage({ action: isOff ? "closethismic" : "openthismic" }); // 開 / 關黑屏
    postAppMessage({
      action: "adjust_volume",
      vol: isOff ? "IsMute" : "unMute",
    });
  }
  return true;
};
